import names from '../actions/actionNames';
import initialState from '../initialState';

const authReducers = (state = initialState.auth, action) => {
  switch (action.type) {
    case names.LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        login: action.data.login,
        accessToken: action.data.accessToken,
        refreshToken: action.data.refreshToken,
        error: null,
        logoutMessage: null
      };
    case names.LOGIN_FAILED:
      return {
        ...state,
        isLoggedIn: false,
        login: null,
        accessToken: null,
        refreshToken: null,
        logoutMessage: null,
        error: action.error
      };
    case names.LOGIN_FAILED_CLEAR_ERROR:
      return {
        ...state,
        logoutMessage: null,
        error: null
      };
    case names.LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
        login: null,
        accessToken: null,
        refreshToken: null,
        error: null,
        logoutMessage: action.message || null
      };
    default:
      return state;
  }
};

export default authReducers;
